export const SET_SEARCH_SELECT_QUERY = "SET_SEARCH_SELECT_QUERY";
export const SET_SEARCH_PARAMS = "SET_SEARCH_PARAMS";
export const SET_NAME_SEARCH_PARAMS = "SET_NAME_SEARCH_PARAMS";
export const FETCH_MAIN_SEARCH_REQUEST = "FETCH_MAIN_SEARCH_REQUEST";
export const FETCH_MAIN_SEARCH_SUCCESS = "FETCH_MAIN_SEARCH_SUCCESS";
export const FETCH_MAIN_SEARCH_FAILURE = "FETCH_MAIN_SEARCH_FAILURE";
